import {
  IAppointmentManager,
  OutlookRecipientDto,
  TokenIAppointmentManager,
} from "../../interfaces";

import { baContainer } from "../../../ioc";
import { AddResourceToOutlookRequest } from "./models/AddResourceToOutlookRequest";
import { IOutlookAppointmentService } from "./IOutlookAppointmentService";
import {
  GetOutlookAppointmentResponse,
  RemoveResourceFromOutlookRequest,
  RemoveResourcesFromOutlookRequest,
} from "./models";
import { ExchangeResourceTypeEnum, OutlookRecipientTypeEnum } from "@/index";

export class OutlookAppointmentService implements IOutlookAppointmentService {
  private _appointmentManager: IAppointmentManager;
  private _startDateTimeInOrganizerTz?: Date;
  private _endDateTimeInOrganizerTz?: Date;
  constructor() {
    this._appointmentManager = baContainer.resolve(TokenIAppointmentManager);
  }
  IsNewBooking(): boolean {
    throw new Error("Method not implemented.");
  }

  GetMessageUrl(): string {
    return this._appointmentManager.GetMessageUrl();
  }
  UpdateBodyForSendToAll(
    sessionKey: string,
    sendToAll: boolean
  ): Promise<boolean> {
    return this._appointmentManager.UpdateBodyForSendToAll(
      sessionKey,
      sendToAll
    );
  }
  UpdateApptDateTimeInOrganizerTimeZone(start: Date, end: Date) {
    this._startDateTimeInOrganizerTz = start;
    this._endDateTimeInOrganizerTz = end;
  }
  GetCurrentAppointment(): GetOutlookAppointmentResponse | undefined {
    let apt: GetOutlookAppointmentResponse | undefined = undefined;
    try {
      const aptEntity = this._appointmentManager.GetAppointment();
      if (aptEntity) {
        apt = {
          StartTimeTicks: aptEntity.StartTimeTicks,
          EndTimeTicks: aptEntity.EndTimeTicks,
          Start: aptEntity.StartTime,
          End: aptEntity.EndTime,
          Uid: aptEntity.Uid,
          Subject: aptEntity.Subject,
          SessionId: aptEntity.SessionId,
          Guid: aptEntity.Guid ?? "",
          GlobalId: aptEntity.GlobalId,
          IsRecurringMaster: aptEntity.IsRecurringMaster,
          IsNoEndDate: aptEntity.IsNoEndDate,
          Occurrences: [],
          ItemId: aptEntity.ItemId,
          IsOccurence: aptEntity.IsOccurence,
          OriginalStart: aptEntity.OriginalStart,
          OriginalEnd: aptEntity.OriginalEnd,
          RecurringAppDuration: aptEntity.RecurringAppDuration,
          HaveOrder: aptEntity.HaveOrder,
          HaveNormalOrder: aptEntity.HaveNormalOrder,
          StartInOrgTz: this._startDateTimeInOrganizerTz,
          EndInOrgTz: this._endDateTimeInOrganizerTz,
          IsReopenAfterSent: aptEntity.IsReopenAfterSent,
          IsReOpen: aptEntity.IsReOpen
        };
        if (aptEntity.Occurrences) {
          apt.Occurrences = aptEntity.Occurrences.map((occ) => {
            return {
              StartTicks: occ.StartTicks,
              EndTicks: occ.EndTicks,
              Start: occ.Start,
              End: occ.End,
              IsDeleted: occ.IsDeleted
            };
          });
        }
      }
    } catch (ex) {
      //console.log(ex);
    }
    return apt;
  }

  AddResource(request: AddResourceToOutlookRequest): boolean {
    // const resourcesAddrs = request?.Resource?.Emails;
    // const outlookRecipients: OutlookRecipientDto[] = resourcesAddrs.map(
    //     (addr) => {
    //         const recipient: OutlookRecipientDto = {
    //             Email: addr.Email,
    //             Name: addr.DisplayName,
    //             ResourceType: request.Resource.ExchangeResourceType
    //         }
    //         return recipient;
    //     }
    // );
    const recipient: OutlookRecipientDto = {
      Email: request.Resource.email,
      Name: request.Resource.displayName,
      RecipientType: OutlookRecipientTypeEnum.Resources, 
      ResourceType: ExchangeResourceTypeEnum.Equipment
    };
    console.log("recipient", recipient);
    
    return this._appointmentManager.AddResources(
      [recipient],
      request.SelectedResourcesLocation
    );
  }

  RemoveResource(request: RemoveResourceFromOutlookRequest): boolean {
    return this._appointmentManager.RemoveResources(
      [request.ResourceEmail],
      request.SelectedResourcesLocation
    );
  }

  RemoveResources(request: RemoveResourcesFromOutlookRequest): boolean {
    return this._appointmentManager.RemoveResources(
      request.ResourceEmails,
      request.SelectedResourcesLocation
    );
  }

  GetCurrentRecipients(): OutlookRecipientDto[] {
    return this._appointmentManager.GetRecipients();
  }
}
